import HttpStatus from 'http-status-codes';
import { BaseError } from './base-error';
import { TranslatableMessage } from '@wiot/shared-domain/models/localization/translatable-message';

export class InvalidArgumentError extends BaseError {
  constructor(message: string | TranslatableMessage = 'GLOBAL.InvalidArgument') {
    super(InvalidArgumentError.name, HttpStatus.BAD_REQUEST, message, true);
  }
}
